///<reference path="../../../../typings/angularjs/angular.d.ts"/>
module TaskList {
    export class TaskSearchController {

        public close() {
            this.$modalInstance.dismiss();
        }
        public searchString: string;
        public results;
        public searchInProgress = false;
        public importInProgress = false;
        public orderBy = "id";
        public reverseSort = false;
        public elementsPerPage = 10;
        public currentPage = 1;

        public changeSort(columnName: string) {
            this.orderBy = columnName;
            this.reverseSort = !this.reverseSort;
            this.results = this.sortData(this.results);
        }

        private sortData(results) {
            return this.naturalSorter.sort(results, this.orderBy, this.reverseSort);
        }

        public search(maxResults?: number) {
            this.searchInProgress = true;
            this.taskService.searchPackages(this.searchString,maxResults).then(result => {
                this.searchInProgress = false;
                if (result.data.success) {
                    this.results = this.sortData(result.data.data);
                    this.addSelectedPackage();
                }
            });
        }

        public addSelectedPackage() {
            this.results.forEach((item) =>
                item.selectedPackage = _.find(item.packageSearchResults, function (i:any){ return i.versionInstalled }) ||  item.packageSearchResults[0]);
        }
       
        public import(id: string, version: string) {
            this.importInProgress = true;
            this.importHandler(id, version).then(() => {
                this.$modalInstance.close();
            });
        }

        constructor(private taskService: TaskListService, private $modalInstance: angular.ui.bootstrap.IModalServiceInstance, public importHandler: (id: string, version: string) => ng.IPromise<void>, private naturalSorter: INaturalSorter) {
            const maxResults = 200;
            this.search(maxResults);
        }
    }
    app.controller("taskSearchController", ["taskListService", "$uibModalInstance", "importHandler", "naturalSorter", TaskSearchController]);
}